import Theme from "@/components/Theme";
import Hero from "@/organisms/Hero";
import FeatureSectionTwocol from "@/organisms/FeatureSectionTwocol";
import ConnectIntegration from "@/organisms/ConnectIntegration";
import Locations from "@/organisms/Locations";
import Discover from "@/organisms/Discover";
import Trustpilot from "@/organisms/Trustpilot";
import AudioLayout from "@/organisms/AudioLayout";
import Slider from "@/components/organisms/Slider";
import ServicesSectionTwoCol from "@/components/organisms/ServicesSectionTwoCol";
import Faq from "@/components/organisms/FaqSection";
import RegistrationForm from "@/components/molecules/RegistrationForm";
import * as california from "@/data/answering-services/california";
import * as texas from "@/data/answering-services/texas";
import * as newyork from "@/data/answering-services/new-york";
import * as denver from "@/data/answering-services/denver";
import * as smallbusiness from "@/data/answering-services/small-business";
import * as afterHoursAnswering from "@/data/answering-services/after-hours-answering";
export async function getStaticPaths() {
  const paths = [
    { params: { answeringServicesPages: "california" } },
    { params: { answeringServicesPages: "texas" } },
    { params: { answeringServicesPages: "new-york" } },
    { params: { answeringServicesPages: "denver" } },
    { params: { answeringServicesPages: "small-business" } },
    { params: { answeringServicesPages: "after-hours-answering" } },
  ];
  return {
    paths: paths,
    fallback: false,
  };
}
export async function getStaticProps({ params: { answeringServicesPages } }) {
  let data = {};
  const contentMap = {
    california,
    texas,
    "new-york": newyork,
    denver,
    "small-business": smallbusiness,
    "after-hours-answering": afterHoursAnswering,
  };
  if (!answeringServicesPages) {
    return {
      notFound: true,
    };
  }
  data.marketing = { ...contentMap[answeringServicesPages]["marketing"] };
  data.content = { ...contentMap[answeringServicesPages]["content"] };
  return {
    props: {
      data,
      pagename: answeringServicesPages,
    },
  };
}
export default function AnsweringServicesPages({ data, pagename }) {
  const seoData = data?.marketing;
  const pagedata = data?.content;
  const hero = pagedata?.hasOwnProperty("hero") && (
    <Hero
      heroTitle={pagedata.hero.title}
      heroContent={pagedata.hero.content}
      heroImgData={pagedata.hero.heroImgData}
      hasPricingCta={pagedata.hero.hasPricingCta}
      hasTrustpilot={pagedata.hero.hasTrustpilot}
    />
  );
  return (
    <Theme mainClassName="main" hero={hero} seo={seoData}>
      {pagename === "after-hours-answering" &&
        pagedata?.hasOwnProperty("audioLayout") && (
          <div>
            <AudioLayout
              title={pagedata.audioLayout.title}
              image={pagedata.audioLayout.image}
              isLPvariant
              isV2AnsweringService
              className={pagedata.audioLayout.className}
            />
          </div>
        )}{" "}
      {pagedata?.hasOwnProperty("featureSectionTwocol1") && (
        <FeatureSectionTwocol
          title={pagedata.featureSectionTwocol1.title}
          image={pagedata.featureSectionTwocol1.image}
          bgColor={pagedata.featureSectionTwocol1.bgColor}
          content={pagedata.featureSectionTwocol1.content}
          isImageOnLeft={pagedata.featureSectionTwocol1.isImageOnLeft}
          hasTitleDot={pagedata.featureSectionTwocol1.hasTitleDot}
          ctaData={pagedata.featureSectionTwocol1.ctaData}
        />
      )}
      {pagedata?.hasOwnProperty("servicesSectionTwoCol") && (
        <ServicesSectionTwoCol
          bgColor={pagedata.servicesSectionTwoCol.bgColor}
          label={pagedata.servicesSectionTwoCol.label}
          title={pagedata.servicesSectionTwoCol.title}
          subText={pagedata.servicesSectionTwoCol.subText}
          listData={pagedata.servicesSectionTwoCol.listData}
          image={pagedata.servicesSectionTwoCol.image}
          contentData={pagedata.servicesSectionTwoCol.contentData}
        />
      )}
      {pagedata?.hasOwnProperty("trustPilot") &&
        (pagename === "after-hours-answering" ? (
          <Trustpilot
            title={pagedata.trustPilot.title}
            variant={pagedata.trustPilot.variant}
            className={pagedata.trustPilot.className}
          />
        ) : null)}
      {pagename !== "after-hours-answering" &&
        pagedata?.hasOwnProperty("slider") && (
          <Slider
            data={pagedata.slider.data}
            variant={pagedata.slider.variant}
            title={pagedata.slider.title}
            subTitle={pagedata.slider.subTitle}
          />
        )}
      {pagedata?.hasOwnProperty("connectIntegration") && (
        <ConnectIntegration
          title={pagedata.connectIntegration.title}
          hasTitleDot={pagedata.connectIntegration.hasTitleDot}
          tileData={pagedata.connectIntegration.tileData}
          bgColor={pagedata.connectIntegration.bgColor}
        />
      )}
      {pagename !== "after-hours-answering" &&
        pagedata?.hasOwnProperty("audioLayout") && (
          <AudioLayout
            title={pagedata.audioLayout.title}
            image={pagedata.audioLayout.image}
          />
        )}
      {pagename === "after-hours-answering" &&
        pagedata?.hasOwnProperty("slider") && (
          <Slider
            data={pagedata.slider.data}
            variant={pagedata.slider.variant}
            title={pagedata.slider.title}
            subTitle={pagedata.slider.subTitle}
          />
        )}
      {pagedata?.hasOwnProperty("tileLessConnectIntegration") && (
        <ConnectIntegration
          title={pagedata.tileLessConnectIntegration.title}
          hasTitleDot={pagedata.tileLessConnectIntegration.hasTitleDot}
          tileData={pagedata.tileLessConnectIntegration.tileData}
          bgColor={pagedata.tileLessConnectIntegration.bgColor}
        />
      )}
      {pagedata?.hasOwnProperty("featureSectionTwocol2") && (
        <FeatureSectionTwocol
          image={pagedata.featureSectionTwocol2.image}
          bgColor={pagedata.featureSectionTwocol2.bgColor}
          isImageOnLeft={pagedata.featureSectionTwocol2.isImageOnLeft}
          hasTitleDot={pagedata.featureSectionTwocol2.hasTitleDot}
          hasRegisterForm={pagedata.featureSectionTwocol2.hasRegisterForm}
          formTitle={pagedata.featureSectionTwocol2.formTitle}
        />
      )}
      {pagedata?.hasOwnProperty("featureSectionTwocol3") && (
        <FeatureSectionTwocol
          title={pagedata.featureSectionTwocol3.title}
          image={pagedata.featureSectionTwocol3.image}
          bgColor={pagedata.featureSectionTwocol3.bgColor}
          content={pagedata.featureSectionTwocol3.content}
          isImageOnLeft={pagedata.featureSectionTwocol3.isImageOnLeft}
          hasTitleDot={pagedata.featureSectionTwocol3.hasTitleDot}
          ctaData={pagedata.featureSectionTwocol3.ctaData}
        />
      )}
      {pagedata?.hasOwnProperty("featureSectionTwocol4") && (
        <FeatureSectionTwocol
          title={pagedata.featureSectionTwocol4.title}
          image={pagedata.featureSectionTwocol4.image}
          bgColor={pagedata.featureSectionTwocol4.bgColor}
          content={pagedata.featureSectionTwocol4.content}
          isImageOnLeft={pagedata.featureSectionTwocol4.isImageOnLeft}
          hasTitleDot={pagedata.featureSectionTwocol4.hasTitleDot}
          ctaData={pagedata.featureSectionTwocol4.ctaData}
          stats={pagedata.featureSectionTwocol4.stats}
        />
      )}
      {pagedata?.hasOwnProperty("locations") && (
        <Locations
          title={pagedata.locations.title}
          para={pagedata.locations.para}
          image={pagedata.locations.image}
          locationData={pagedata.locations.locationData}
        />
      )}
      {pagename !== "after-hours-answering" &&
        pagedata?.hasOwnProperty("trustPilot") && (
          <Trustpilot
            title={pagedata.trustPilot.title}
            variant={pagedata.trustPilot.variant}
            className={pagedata.trustPilot.className}
          />
        )}
      {pagedata?.hasOwnProperty("miniRegister") && (
        <RegistrationForm
          title={pagedata.miniRegister.title}
          content={pagedata.miniRegister.content}
          hasBusinessNameField={false}
          variant="mini"
          formUniqueName={`page-${pagename}-mini`}
        ></RegistrationForm>
      )}
      {pagedata?.hasOwnProperty("faq") && <Faq data={pagedata.faq.faqData} />}
      {pagedata?.hasOwnProperty("discover") && (
        <Discover
          bgColor={pagedata.discover.bgColor}
          title={pagedata.discover.title}
          color={pagedata.discover.color}
          cta={pagedata.discover.cta}
          href={pagedata.discover.href}
        />
      )}
    </Theme>
  );
}
